import { STRING } from 'resources'

export const formatProfileInfo = (profileInfo) => {
  if (
    profileInfo?.userProfile === null ||
    profileInfo?.emailAddresses === null ||
    profileInfo?.userProfile?.error ||
    profileInfo?.emailAddresses?.error
  ) {
    return { error: true }
  }

  let primaryEmail
  if (profileInfo?.emailAddresses && profileInfo?.emailAddresses.length > 0) {
    primaryEmail = profileInfo.emailAddresses.find((email) => email?.isPrimary)?.emailAddress
  }

  const addressParts = [
    profileInfo.userProfile?.address || STRING.emDash,
    profileInfo.userProfile?.address2 ?? STRING.emDash,
    profileInfo.userProfile?.city || STRING.emDash,
    profileInfo.userProfile?.state || STRING.emDash,
    profileInfo.userProfile?.zip || STRING.emDash,
  ]
  const addressText = addressParts.filter(Boolean).join(', ')

  return {
    name: {
      label: STRING.protect.profileInfo.nameLabel,
      value: `${profileInfo.userProfile?.firstName || STRING.emDash} ${
        profileInfo.userProfile?.lastName || STRING.emDash
      }`,
    },
    email: {
      label: STRING.protect.profileInfo.emailLabel,
      value: `${primaryEmail || STRING.emDash}`,
    },
    address: {
      label: STRING.protect.profileInfo.addressLabel,
      value: addressText,
    },
    birthDate: {
      label: STRING.protect.profileInfo.birthDateLabel,
      value: `${profileInfo.userProfile.birthDate || STRING.emDash}`,
    },
  }
}
